import { ParamsList } from 'parkway-web-common'

export const JobTitleGroupKeys = {
  allJobTitleGroups: ['JobTitleGroups'] as const,
  listJobTitleGroups: () =>
    [...JobTitleGroupKeys.allJobTitleGroups, 'JobTitleGroups'] as const,
  listJobTitleGroup: (filters?: ParamsList) =>
    [...JobTitleGroupKeys.listJobTitleGroups(), { filters }] as const,
}
